import React, { Component } from 'react';

import PropTypes from 'prop-types';

import SearchInput from './SearchInput';

export default class SearchInputFilter extends Component {
  static SearchInput = SearchInput;

  static propTypes = {
    children: PropTypes.node,
    items: PropTypes.array
  };

  static defaultProps = {
    items: []
  };

  render() {
    const { children } = this.props;

    return React.Children.map(children, (child) => {
      const { name } = child.type;

      return name === 'SearchInput'
        ? this.renderSearch(child)
        : this.renderList(child);
    });
  }

  renderSearch(child) {
    return React.cloneElement(child, { ...child.props });
  }

  renderList(child) {
    const { items } = this.props;

    return React.cloneElement(child, { ...child.props, items });
  }
}
